module.exports = __webpack_public_path__ + "img/youmu konpaku lunar war gardener_lw.6d472ffd.png";